import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from '../store/schema/ReadWriteRecipientViewState';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

/**
 * Maps FindRecipientPersonaType to ReadWriteRecipientViewState
 */
export default function(
    newPersona: FindRecipientPersonaType,
    isValid: boolean,
    newEmailAddress?: string
): ReadWriteRecipientViewState {
    if (!newPersona) {
        // construct the email address wrapper if it's not provided.
        newPersona = {
            EmailAddress: {
                MailboxType: 'OneOff',
                RoutingType: 'SMTP',
                EmailAddress: newEmailAddress,
                Name: newEmailAddress,
            },
        };
    }

    let displayText = newPersona.EmailAddress.Name
        ? newPersona.EmailAddress.Name
        : newPersona.EmailAddress.EmailAddress;

    if (!isConsumer()) {
        let emailDomain = newPersona.EmailAddress.EmailAddress
            ? newPersona.EmailAddress.EmailAddress.split('@')[1]
            : '';

        let isExternalMailboxType =
            newPersona.EmailAddress.MailboxType === 'ExternalMailbox' ||
            newPersona.EmailAddress.MailboxType === 'LinkedIn';

        // this is for when name is a SMTP.
        // If the name is SMTP, then if the domain of the display text is different than Email Address then show the email address domain
        // If they are the same, do not show the domain name after name.
        if (
            displayText &&
            (!isValidEmailAddress(displayText) || displayText.split('@')[1] !== emailDomain) &&
            isExternalMailboxType
        ) {
            displayText = `${displayText} (${emailDomain})`;
        }
    }

    return {
        persona: newPersona,
        displayText: displayText,
        isValid: isValid,
        isContextMenuOpen: false,
        isSelected: false,
        isExpanding: false,
        isEditing: false,
        isFadedOut: false,
    };
}
